import { TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { useSelector, useDispatch } from "react-redux"
import { addAdultosAction, addMenoresAction, addInfantesAction, addPaqueteAction, obtenerPaquetesAction, addItemsAction, resetStateAction } from "../../../../ducks/cotizadorPaqueteDuck"
import handleRenderOption from "./handleRenderOption"
import { useEffect } from "react"

const InitialValuePaquete = {
    Nombre: "",
    ClavePaquete: "0",
}

const CbPaquete = () => {
    const { categoria, listaPaquetes, paquete, cantidadPasajeros } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerPaquetesAction({ IdCategoria: categoria.IdCategoriaPaquete }))
    }, [dispatch, categoria.IdCategoriaPaquete])
    const getOptionHangle = (event, valor) => {
        dispatch(resetStateAction())
        if (valor) {
            let arraItems = []
            let itemPaquete = {
                id: valor.envioPaqueteProveedor?.IdObjeto,
                name: valor.Nombre,
                price: valor.PrecioPublico,
                currency: valor.Moneda?.Clave,
                type: "PAQUETE",
                quantity: cantidadPasajeros
            }
            arraItems.push(itemPaquete)
            dispatch(addPaqueteAction({ paquete: valor }))
            dispatch(addItemsAction({listaItem: arraItems}))
            dispatch(addAdultosAction({ cantidad: 0 }))
            dispatch(addMenoresAction({ cantidad: 0 }))
            dispatch(addInfantesAction({ cantidad: 0 }))
        } else {
            dispatch(addPaqueteAction({ paquete: InitialValuePaquete }))
            dispatch(addItemsAction({listaItem: []}))
            dispatch(addAdultosAction({ cantidad: 0 }))
            dispatch(addMenoresAction({ cantidad: 0 }))
            dispatch(addInfantesAction({ cantidad: 0 }))
        }
    }
    return (
        <div style={{ margin: "2% 0" }}>
            <Autocomplete
                value={paquete}
                id={`id-auto-Paquete`}
                options={listaPaquetes.sort((a, b) => a.Nombre > b.Nombre)}
                getOptionLabel={(option) => {
                    return `${option.Nombre}`
                }}
                style={{
                    width: "97%",
                    margin: "2% 0",
                    paddingBottom: "0",
                    fontWeight: "500",
                }}
                disabled={listaPaquetes.length > 0 ? false : true}
                onChange={getOptionHangle}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Paquetes"
                        variant="outlined"
                        style={{ width: "100%" }}
                        name="paquetes"
                    />
                )}
                renderOption={handleRenderOption}
            />
        </div>
    )
}
export default CbPaquete